import LevelOverviewSection from './LevelOverviewSection';
import CategoryCardGrid from './CategoryCardGrid';
import { HEADER_IMAGES } from './constants';
import {
  HeaderRow,
  HeaderLeft,
  Avatar,
  NameColumn,
  UserName,
  DateRow,
  CalendarIcon,
  DateText,
} from './styled-components';
import useGamification from './useGamification';

const GAMIFICATION_RELEASE_DATE = new Date('2026-03-16T00:00:00');

const Gamification = ({
  cardStyle,
  isExternal,
  userAchievements = [],
}) => {
  const { categories, levelSummaries, firstname, name, isLocalOrStaging, createdAt } = useGamification({userAchievements});

  if (isExternal || (!isLocalOrStaging && new Date() < GAMIFICATION_RELEASE_DATE)) {
    return null
  }

  return (
    <div className={cardStyle}>
      <HeaderRow>
        <HeaderLeft>
          <Avatar src={HEADER_IMAGES.avatar} alt="Avatar" />
          <NameColumn>
            <UserName>{firstname} {name}</UserName>
            <DateRow>
              <CalendarIcon src={HEADER_IMAGES.calendarIcon} alt="" />
              <DateText>{createdAt ? new Date(createdAt).toLocaleDateString() : 'Non disponible'}</DateText>
            </DateRow>
          </NameColumn>
        </HeaderLeft>
      </HeaderRow>

      <LevelOverviewSection levelSummaries={levelSummaries} />
      <CategoryCardGrid categories={categories} />
    </div>
  );
};

export default Gamification;
